export enum FileType {
  Playground = 'PLAYGROUND',
  Template = 'TEMPLATE'
}
